module.exports = __webpack_public_path__ + "static/img/dianxin.c751c49a.png";